import { useEffect } from 'react'

import { fetchLatestPublishedAt } from './service/changelog'
import { useUpdatesStore } from './store'

let latestFetchStarted = false

export const useTrackLatestUpdate = () => {
  const noteLatestPublishedAt = useUpdatesStore(
    (state) => state.noteLatestPublishedAt,
  )
  useEffect(() => {
    if (latestFetchStarted) return
    latestFetchStarted = true
    fetchLatestPublishedAt()
      .then(noteLatestPublishedAt)
      .catch(() => {})
  }, [noteLatestPublishedAt])
}

export const useHasUnreadUpdates = () => {
  const lastSeenAt = useUpdatesStore((state) => state.lastSeenAt)
  const latestPublishedAt = useUpdatesStore((state) => state.latestPublishedAt)
  return Boolean(
    latestPublishedAt && (!lastSeenAt || latestPublishedAt > lastSeenAt),
  )
}

export const useMarkUpdatesSeen = () =>
  useUpdatesStore((state) => state.markSeen)

export const getLastSeenAt = () => useUpdatesStore.getState().lastSeenAt

export const noteLatestPublishedAt = (at: string | null) =>
  useUpdatesStore.getState().noteLatestPublishedAt(at)
